"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ModalContext", {
    enumerable: true,
    get: function() {
        return ModalContext;
    }
});
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const ModalContext = /*#__PURE__*/ _react.default.createContext({
    title: "Unknown",
    scrollable: false,
    show: false,
    modalBodyRef: null,
    onHide: ()=>undefined,
    headerBorder: true,
    setHeaderBorder: ()=>undefined,
    stickyHeader: false,
    setStickyHeader: ()=>undefined,
    stickyFooter: false,
    setStickyFooter: ()=>undefined,
    size: "md",
    withFooter: false
});

//# sourceMappingURL=ModalContext.js.map